import { render } from "./CarsPagination.vue?vue&type=template&id=4fc087fb&scoped=true"
import script from "./CarsPagination.vue?vue&type=script&lang=js"
export * from "./CarsPagination.vue?vue&type=script&lang=js"

import "./CarsPagination.vue?vue&type=style&index=0&id=4fc087fb&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Tomer\\projects\\pmaculator-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fc087fb"]])

export default __exports__